export default function handleOptionSelectHelper(
  event,
  name,
  option,
  setSelectedValue,
  formik
) {
  const { setFieldValue } = formik;
  // console.log("option: ", option);
  // setOptions(option ? [option, ...options] : options);
  if (
    name === "nomineeDetails.NomineeAddress.Pincode" ||
    name === "proposerDetails.CommunicationAddress.Pincode" ||
    name === "proposerDetails.PermanentAddress.Pincode"
  ) {
    setFieldValue(name, option.pin_code); // Set the selected option using Formik's setFieldValue

    const {
      state_id,
      state_name,
      district_id,
      district_name,
      city_or_village_id,
      city_or_village_name,
      area_id,
      area_name,
    } = option;

    // Communication Address
    if (name === "proposerDetails.CommunicationAddress.Pincode") {
      setFieldValue("proposerDetails.CommunicationAddress.AreaID", area_id);
      setFieldValue("proposerDetails.CommunicationAddress.Area", area_name);
      setFieldValue(
        "proposerDetails.CommunicationAddress.CityID",
        city_or_village_id
      );
      setFieldValue(
        "proposerDetails.CommunicationAddress.City",
        city_or_village_name
      );
      setFieldValue(
        "proposerDetails.CommunicationAddress.DistrictID",
        district_id
      );
      setFieldValue(
        "proposerDetails.CommunicationAddress.District",
        district_name
      );
      setFieldValue("proposerDetails.CommunicationAddress.StateID", state_id);
      setFieldValue("proposerDetails.CommunicationAddress.State", state_name);
    } else if (name === "proposerDetails.PermanentAddress.Pincode") {
      // Permanent Address
      setFieldValue("proposerDetails.PermanentAddress.AreaID", area_id);
      setFieldValue("proposerDetails.PermanentAddress.Area", area_name);
      setFieldValue(
        "proposerDetails.PermanentAddress.CityID",
        city_or_village_id
      );
      setFieldValue(
        "proposerDetails.PermanentAddress.City",
        city_or_village_name
      );
      setFieldValue("proposerDetails.PermanentAddress.DistrictID", district_id);
      setFieldValue("proposerDetails.PermanentAddress.District", district_name);
      setFieldValue("proposerDetails.PermanentAddress.StateID", state_id);
      setFieldValue("proposerDetails.PermanentAddress.State", state_name);
    } else if (name === "nomineeDetails.NomineeAddress.Pincode") {
      // Permanent Address
      setFieldValue("nomineeDetails.NomineeAddress.AreaID", area_id);
      setFieldValue("nomineeDetails.NomineeAddress.Area", area_name);
      setFieldValue("nomineeDetails.NomineeAddress.CityID", city_or_village_id);
      setFieldValue("nomineeDetails.NomineeAddress.City", city_or_village_name);
      setFieldValue("nomineeDetails.NomineeAddress.DistrictID", district_id);
      setFieldValue("nomineeDetails.NomineeAddress.District", district_name);
      setFieldValue("nomineeDetails.NomineeAddress.StateID", state_id);
      setFieldValue("nomineeDetails.NomineeAddress.State", state_name);
    }
  }
}
